export const RUNLIST_INITIALIZE = 'PAGE_RUNLIST_INITIALIZE';
export const SET_ACTIVE_RUNLIST_FILTER = 'PAGE_SET_ACTIVE_RUNLIST_FILTER';
export const SET_ACTIVE_RUNLIST_GROUPING = 'PAGE_SET_ACTIVE_RUNLIST_GROUPING';
export const SET_ACTIVE_RUNLIST_SORTING = 'PAGE_SET_ACTIVE_RUNLIST_SORTING';
export const SET_USER_IS_ADMIN = 'PAGE_SET_USER_IS_ADMIN';
export const SET_USER_ONLY_RUNS = 'PAGE_SET_USER_ONLY_RUNS';

export function initialize() {
  return {
    type: RUNLIST_INITIALIZE
  };
}

export function setRunListFilter(filter) {
  return {
    type: SET_ACTIVE_RUNLIST_FILTER,
    filter
  };
}

export function setRunListGrouping(grouping) {
  return {
    type: SET_ACTIVE_RUNLIST_GROUPING,
    grouping
  };
}

export function setRunListSorting(sorting) {
  return {
    type: SET_ACTIVE_RUNLIST_SORTING,
    sorting
  };
}

export function setUserOnlyRuns(setting) {
  return {
    type: SET_USER_ONLY_RUNS,
    setting
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/run/RunList.js